module.exports = __webpack_public_path__ + "static/media/1.f0e75e53.jpg";